<template>
  <div>
    <g-master name="greport_params"
              :endpoint="reportMaster.endpoint"
              :tableSetup="reportMaster.tableSetup"
              :modalFieldsSetup="reportMaster.modalFieldsSetup"
              :parentData="jbParentData"
              modalWidth="80%"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Columna: ">
              <a-input
                v-decorator="['column', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Etiqueta: ">
              <a-input
                v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Interno " :has-feedback="false">
              <a-checkbox v-decorator="['interno', {valuePropName: 'checked'}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        label="Tipo de dato: "
                        :formItemConfig="fiOptions"
                        :selectedObj.sync="tipoDatoSeleccionado"
                        :decorator="['id_h_param_type', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                        :params="id_h_param_type">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Requerido: " :has-feedback="false">
              <a-checkbox v-decorator="['required', {valuePropName: 'checked'}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Parámetro SQL')" v-bind="fiOptions">
              <a-textarea autoSize
                          v-decorator="['param_sql', { rules: [{ required: requiredParamSQL, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="ITEMS" key="1">
        <greportparaitem v-if="idGreportParam" :id_g_report_param="idGreportParam"/>
        <span v-else>Seleccione una evaluación para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    props: ['id_g_report'],
    computed: {
      jbParentData () {
        return {
          id_g_report: this.id_g_report
        }
      },
      idGreportParam () {
        return this.reportMaster.tableSetup.selectedRows.length > 0 ? this.reportMaster.tableSetup.selectedRows[0].id : null
      }
    },
    watch: {
      tipoDatoSeleccionado () {
        if (this.tipoDatoSeleccionado.text === 'LOV_SQL') {
          this.requiredParamSQL = true
        } else {
          this.requiredParamSQL = false
        }
      }
    },
    data () {
      return {
        tipoDatoSeleccionado: {},
        requiredParamSQL: false,
        id_h_param_type: {
          h_lookup_type: 'G_REPORTE_PARAM_TYPE'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        reportMaster: {
          endpoint: 'greport_params',
          tableSetup: {
            tableConfig: { //
              rowKey: 'id'
            },
            columns: [
              {title: 'Columna', dataIndex: 'column', sorter: true},
              {title: 'Etiqueta', dataIndex: 'label', sorter: true},
              {title: 'Tipo de parametro', dataIndex: 'h_param_type', sorter: true},
              {title: 'Requerido', dataIndex: 'required_desc', sorter: true},
              {title: 'Parámetro SQL', dataIndex: 'param_sql', sorter: true},
              {title: 'Interno', dataIndex: 'interno_desc', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'column'},
            {name: 'label'},
            {name: 'id_h_param_type'},
            {name: 'required'},
            {name: 'param_sql'},
            {name: 'interno', type: 'boolean'}
          ]
        }
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Greport/ReportParams.vue